import { IHinhThucTinhActionTypes } from "../../action-types/mien-giam/IHinhThucTinhActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHinhThucTinhReducer } from "../../reducer-model/mien-giam/IHinhThucTinhReducer";
const iniState: IHinhThucTinhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  hinhThucTinhs: [],
};
export const hinhThucTinhReducer = (
  state: IHinhThucTinhReducer = iniState,
  action: IHinhThucTinhActionTypes
): IHinhThucTinhReducer => {
  switch (action.type) {
    case "HINH_THUC_TINH_MIEN_GIAM_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "HINH_THUC_TINH_MIEN_GIAM_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        hinhThucTinhs: action.payload,
      };
    case "HINH_THUC_TINH_MIEN_GIAM_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
